import React from 'react';
import ClientSlider from './ClientSlider';
import Heading from '../Headers/Heading';
import clients from '../../Data/clients';

function ClientSection() {
    return (
        <div className="client-section">
            <div className="client-section-wrapper">
                <div className="container">
                    <div className="client-section-header">
                        <Heading 
                            heading={<h3>Trusted By</h3>}
                            headingClass="heading-large dark-1"
                            paragraphClass="dark-2"
                            paragraph="Our solutions are used in applied training and learning environments to make learning safer, more effective, and more engaging."
                        />
                    </div>
                    <ClientSlider slides={clients} />
                    <div className="d-none client-slider-1">
                        <ClientSlider slides={clients} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClientSection;
